import React, {Component} from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import {Scrollbars} from 'react-custom-scrollbars';
import styles from './ScrollableDialog.scss';

import Dialog from './Dialog';

export default class ScrollableDialog extends Dialog {
    getDialogContent() {
        const {
            title,
            children,
            containerClassName,
            contentClassName,
            headerClassName,
            scrollbarRef,
            isLong,
            withConfirmation,
        } = this.props;

        const bodyClassName = classNames(containerClassName, styles.body);
        const wrapper = classNames(contentClassName, styles.contentWrapper, isLong ? styles.long : '');
        const header = classNames(headerClassName, styles.header);
        const scrollBarConfig = this.getScrollBarConfig();

        return (
            <div className={wrapper}>
                <Scrollbars
                    ref={scrollbarRef}
                    className={styles.scrollbar}
                    {...scrollBarConfig}
                >
                    <header className={header}>
                        {title}
                    </header>

                    <section className={bodyClassName}>
                        {children}
                        {withConfirmation && this.renderConfirmation()}
                    </section>
                </Scrollbars>
            </div>
        );
    }

    getScrollBarConfig() {
        return this.props.scrollBarConfig || {};
    }
}



// WEBPACK FOOTER //
// ./src/components/controls/dialogs/ScrollableDialog.js